"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Slider;

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.parse-float.js");

var _SliderModule = _interopRequireDefault(require("../../assets/styles/components/Slider.module.scss"));

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Slider(_ref) {
  let {
    onChange,
    min = "0",
    max = "100",
    value = "0",
    persistentThumb,
    step = "1",
    disabled,
    styling = {}
  } = _ref;
  const [valueSlider, setvalueSlider] = (0, _react.useState)(value);
  const [leftPostion, setleftPostion] = (0, _react.useState)(0);
  const inputRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (inputRef.current) {
      setleftPostion((parseFloat(value) - parseFloat(min)) / (parseFloat(max) - parseFloat(min)) * (inputRef.current.offsetWidth - 10 - 10) - 12);
    }
  }, [inputRef]);

  const changeSlider = e => {
    setvalueSlider(e.currentTarget.value);
    onChange(e.currentTarget.value);
    const left = (e.currentTarget.value - parseFloat(min)) / (parseFloat(max) - parseFloat(min)) * (inputRef.current.offsetWidth - 10 - 10) - 12;
    setleftPostion(left);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _SliderModule.default.slider,
    style: styling,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      disabled: disabled,
      step: step,
      ref: inputRef,
      onChange: e => {
        changeSlider(e);
      },
      type: "range",
      min: min,
      max: max,
      value: valueSlider
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        left: leftPostion + "px"
      },
      className: "".concat(_SliderModule.default.value_container, " ").concat(persistentThumb ? _SliderModule.default.value_container_persistentThumb : ''),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: valueSlider
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: _SliderModule.default.min_value,
      children: min
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: _SliderModule.default.max_value,
      children: max
    })]
  });
}